import { render, staticRenderFns } from "./BcIntermediary.vue?vue&type=template&id=ebacd862&"
import script from "./BcIntermediary.vue?vue&type=script&lang=js&"
export * from "./BcIntermediary.vue?vue&type=script&lang=js&"
import style0 from "./BcIntermediary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports